import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconChevronUpComponent } from "./med-icon-chevron-up.component";

@NgModule({
  declarations: [
    MedIconChevronUpComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconChevronUpComponent,
  ],
})
export class MedIconChevronUpModule { }
